export default __webpack_public_path__ + "static/media/SJA1510.34I-42087_-25234_0.890587bf.jpg";